import bilAPI from "../api";

export const getAccountInfo = () => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .get("/auth/account_info/")
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject("axios error", err);
        });
    } catch (error) {
      reject("system error", error);
    }
  });
};

export const getAccounts = (params = {}) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .get("/auth/account/", { params }) // e.g. { page, page_size, search, ordering }
        .then((res) => {
          resolve(res.data); // { count, next, previous, results: [...] }
        })
        .catch((err) => {
          reject("axios error", err);
        });
    } catch (error) {
      reject("system error", error);
    }
  });
};

// GET one account by uuid
export const getAccountById = (uuid) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .get(`/auth/account/${uuid}/`)
        .then((res) => resolve(res.data))
        .catch((err) => reject("axios error", err));
    } catch (error) {
      reject("system error", error);
    }
  });
};

// PUT (full update) account
export const updateAccountPut = (uuid, payload) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .put(`/auth/account/${uuid}/`, payload)
        .then((res) => resolve(res.data))
        .catch((err) => reject("axios error", err));
    } catch (error) {
      reject("system error", error);
    }
  });
};

// PATCH (partial update) account
export const updateAccountPatch = (uuid, payload) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .patch(`/auth/account/${uuid}/`, payload)
        .then((res) => resolve(res.data))
        .catch((err) => reject("axios error", err));
    } catch (error) {
      reject("system error", error);
    }
  });
};

// DELETE account
export const deleteAccount = (uuid) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .delete(`/auth/account/${uuid}/`)
        .then((res) => resolve(res.data))
        .catch((err) => reject("axios error", err));
    } catch (error) {
      reject("system error", error);
    }
  });
};

export const createAccount = (
  name,
  surname,
  email,
  roleUuid,
  organizationUuid
) => {
  return new Promise((resolve, reject) => {
    try {
      const accountData = {
        first_name: name,
        last_name: surname,
        email,
        role: roleUuid,
        organization: organizationUuid,
      };

      bilAPI
        .post("/auth/account/", accountData)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject("axios error", err);
        });
    } catch (error) {
      reject("system error", error);
    }
  });
};

export const addRoleToAccount = (userUuid, roleId) => {
  return new Promise((resolve, reject) => {
    try {
      const roleData = {
        uuid: userUuid,
        role_id: roleId,
      };

      bilAPI
        .post("/auth/account/add-role/", roleData)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject("axios error", err);
        });
    } catch (error) {
      reject("system error", error);
    }
  });
};

export const getRoles = (params = {}) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .get("/permission/role/", { params })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject("axios error", err);
        });
    } catch (error) {
      reject("system error", error);
    }
  });
};
